let apiUri: string;

if (process.env.NODE_ENV === 'development') {
  apiUri = 'http://localhost:3100/api';
} else if (process.env.NODE_ENV === 'production') {
  apiUri = 'https://admin.uat.baydaarexp.com/api';
}

export { apiUri };
